
  <div class="table-wrapper-scroll-y my-custom-scrollbar">

    <table class="table table-bordered table-striped mb-0">
      <caption class="caption"></caption>
      <thead>

        <tr>
          <th *ngFor="let dataModel of dataModelList">{{dataModel.columnReference}}</th>

        </tr>
      </thead>

      <tbody>

        <tr *ngFor="let item of data">
          <td *ngFor="let dataModel of dataModelList;let index=index;" [style.background-color]="IsColError(dataModel.idx,item.errors) ? 'red' : 'transparent' ">
            <span *ngIf="dataModel.columnReference==='application Date'; else elseBlock ">{{item[dataModel.columnName] |  date:'MMMM dd, yyyy' }}</span>
            <ng-template #elseBlock>{{item[dataModel.columnName] }}</ng-template>
          </td>

        </tr>

      </tbody>
    </table>
  </div>
